<template>
  <bm-number
    v-bind="$attrs"
    :min="min"
    :max="max"
    :suffix="suffix"
    :value="value"
    @input="$emit('input', $event)"
  ></bm-number>
</template>

<script lang="ts">
import messages from "@/plugins/i18n";
import { defineComponent } from "vue";
/**
 * Control that represents alcohol content in a liquid.
 * TODO: Load from tenant settings.
 */
export default defineComponent({
  name: "BmAlcoholContent",
  props: {
    value: {
      type: Number,
      required: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    suffix: {
      type: String,
      default: messages.percent_abv,
    },
  },
});
</script>
